// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.industries-we-work-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.industries-we-work-section .industries-we-work-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .cards-grid {
  --cards-grid-number: 2;
  --cards-grid-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(var(--cards-grid-number), 1fr);
  gap: var(--cards-grid-gap);
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card {
  width: 100%;
  height: 100%;
  background-color: var(--secondaryMain-1000);
  border-radius: 2.5rem 2.5rem 2rem 2rem;
  box-shadow: 0px 4px 4px var(--black-150);
  display: flex;
  flex-direction: column;
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header {
  width: 100%;
  background-color: var(--secondaryMain-1000);
  border-radius: 2.5rem 2.5rem 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.75rem;
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header .icon-box {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  background-color: var(--white-1000);
  border-radius: 0.5rem;
  box-shadow: 0px 4px 4px var(--black-150);
  display: flex;
  justify-content: center;
  align-items: center;
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header .icon-box img {
  width: 75%;
  min-width: 75%;
  height: 75%;
  object-fit: contain;
  object-position: center;
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header .title-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.4;
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-body {
  width: 100%;
  background-color: var(--white-1000);
  border-radius: 2rem;
  flex-grow: 1;
  padding: 1.25rem 1.75rem;
}
.industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-body .para-text {
  color: var(--outerSpace-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
@media screen and (max-width: 991.98px) {
  .industries-we-work-section {
    padding: 2.5rem 0;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1.25rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card {
    border-radius: 1.5rem 1.5rem 1rem 1rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header {
    border-radius: 1.5rem 1.5rem 0 0;
    padding: 1rem 1.25rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header .icon-box {
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header .title-text {
    font-size: 1rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-body {
    border-radius: 1rem;
    padding: 1rem 1.25rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-body .para-text {
    font-size: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .industries-we-work-section {
    padding: 2rem 0;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header {
    gap: 0.75rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header .icon-box {
    width: 2.25rem;
    min-width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.25rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-header .title-text {
    font-size: 0.875rem;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .card .card-body .para-text {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 639.98px) {
  .industries-we-work-section {
    padding: 2rem 0;
  }
  .industries-we-work-section .industries-we-work-wrap .industries-we-work-box .cards-grid {
    --cards-grid-number: 1;
    --cards-grid-gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/IndustriesWeWorkSection/IndustriesWeWorkStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,4DAAA;EACA,0BAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,sCAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;AADR;AAGQ;EACE,WAAA;EACA,2CAAA;EACA,gCAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;AADV;AAGU;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mCAAA;EACA,qBAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADZ;AAGY;EACE,UAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AADd;AAKU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHZ;AAOQ;EACE,WAAA;EACA,mCAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;AALV;AAOU;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AALZ;AAYE;EAnFF;IAoFI,iBAAA;EATF;EAaM;IACE,sBAAA;IACA,yBAAA;EAXR;EAcM;IACE,sCAAA;EAZR;EAcQ;IACE,gCAAA;IACA,qBAAA;EAZV;EAcU;IACE,cAAA;IACA,kBAAA;IACA,eAAA;EAZZ;EAeU;IACE,eAAA;EAbZ;EAiBQ;IACE,mBAAA;IACA,qBAAA;EAfV;EAiBU;IACE,eAAA;EAfZ;AACF;AAsBE;EA5HF;IA6HI,eAAA;EAnBF;EAuBM;IACE,sBAAA;IACA,sBAAA;EArBR;EAyBQ;IACE,YAAA;EAvBV;EAyBU;IACE,cAAA;IACA,kBAAA;IACA,eAAA;IACA,sBAAA;EAvBZ;EA0BU;IACE,mBAAA;EAxBZ;EA6BU;IACE,mBAAA;EA3BZ;AACF;AAkCE;EAhKF;IAiKI,eAAA;EA/BF;EAmCM;IACE,sBAAA;IACA,sBAAA;EAjCR;AACF","sourcesContent":[".industries-we-work-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .industries-we-work-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .industries-we-work-box {\n      .cards-grid {\n        --cards-grid-number: 2;\n        --cards-grid-gap: 2rem;\n        display: grid;\n        grid-template-columns: repeat(var(--cards-grid-number), 1fr);\n        gap: var(--cards-grid-gap);\n      }\n\n      .card {\n        width: 100%;\n        height: 100%;\n        background-color: var(--secondaryMain-1000);\n        border-radius: 2.5rem 2.5rem 2rem 2rem;\n        box-shadow: 0px 4px 4px var(--black-150);\n        display: flex;\n        flex-direction: column;\n      \n        .card-header {\n          width: 100%;\n          background-color: var(--secondaryMain-1000);\n          border-radius: 2.5rem 2.5rem 0 0;\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          gap: 1rem;\n          padding: 1.25rem 1.75rem;\n\n          .icon-box {\n            width: 4rem;\n            min-width: 4rem;\n            height: 4rem;\n            background-color: var(--white-1000);\n            border-radius: 0.5rem;\n            box-shadow: 0px 4px 4px var(--black-150);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            img {\n              width: 75%;\n              min-width: 75%;\n              height: 75%;\n              object-fit: contain;\n              object-position: center;\n            }\n          }\n\n          .title-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 700;\n            line-height: 1.4;\n          }\n        }\n\n        .card-body {\n          width: 100%;\n          background-color: var(--white-1000);\n          border-radius: 2rem;\n          flex-grow: 1;\n          padding: 1.25rem 1.75rem;\n\n          .para-text {\n            color: var(--outerSpace-1000);\n            font-size: 1.5rem;\n            font-weight: 400;\n            line-height: 1.4;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .industries-we-work-wrap {  \n      .industries-we-work-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1.25rem;\n        }\n  \n        .card {\n          border-radius: 1.5rem 1.5rem 1rem 1rem;\n        \n          .card-header {\n            border-radius: 1.5rem 1.5rem 0 0;\n            padding: 1rem 1.25rem;\n\n            .icon-box {\n              width: 2.75rem;\n              min-width: 2.75rem;\n              height: 2.75rem;\n            }\n  \n            .title-text {\n              font-size: 1rem;\n            }\n          }\n  \n          .card-body {\n            border-radius: 1rem;\n            padding: 1rem 1.25rem;\n  \n            .para-text {\n              font-size: 1rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .industries-we-work-wrap {  \n      .industries-we-work-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1rem;\n        }\n  \n        .card {        \n          .card-header { \n            gap: 0.75rem;\n            \n            .icon-box {\n              width: 2.25rem;\n              min-width: 2.25rem;\n              height: 2.25rem;\n              border-radius: 0.25rem;\n            }\n\n            .title-text {\n              font-size: 0.875rem;\n            }\n          }\n  \n          .card-body {  \n            .para-text {\n              font-size: 0.875rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .industries-we-work-wrap {  \n      .industries-we-work-box {\n        .cards-grid {\n          --cards-grid-number: 1;\n          --cards-grid-gap: 1rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
